import type {EventOptions, HookEventData, HooksDefinition} from '../extensions/hooks/hooks'

export const createHookDefinition = <E extends string, D>(
    event: E,
    eventOptions?: EventOptions
): HooksDefinition<E, D> => {
    const createEvent = (data: Omit<D, keyof HookEventData<E>> | (D & HookEventData<E>)): D & HookEventData<E> => {
        ;(data as D & HookEventData<E>).event = event
        if (eventOptions) {
            ;(data as D & HookEventData<E>).eventOptions = eventOptions
        }
        return data as D & HookEventData<E>
    }
    return {
        id: event,
        createEvent
    }
}
